import { AppRoutes, GTMEvent } from 'src/types';
import { sendGTMEvent } from 'src/utils';
import { useNavigate } from 'react-router-dom';
import {
  useGetUser,
  useRequestUpgradeModal,
  useSubscriptionInfo,
  useTeamInfo,
} from 'src/hooks';
import { toast } from 'react-toastify';
import {
  APPLE_PAYMENT_UPGRADE_ERROR_TEXT,
  SUBSCRIPTION_PENDING_CHANGES_NOTIFICATION_MESSAGE,
} from 'src/constants';
import classNames from 'classnames';
import { Button, ButtonProps } from 'src/v2/commonComponents/Button';
import { useChatHistory } from 'src/hooks';
type UpgradeButtonProps = {
  onClick?: () => void;
  title?: string;
  dataGTM: string;
  className?: string;
  color?: ButtonProps['color'];
};

export const UpgradeButton = ({
  onClick,
  title = 'Upgrade',
  dataGTM,
  className,
  color,
}: UpgradeButtonProps) => {
  const { isNinjaRetired } = useChatHistory();
  const { isTeamsTier } = useGetUser();
  const navigate = useNavigate();
  const { subscriptionInfo, isSubscriptionInfoLoading, isAppleOrAmpPayment } =
    useSubscriptionInfo();
  const { onOpenRequestUpgradeModal } = useRequestUpgradeModal();
  const { isOwner } = useTeamInfo();

  const handleUpgradeClick = () => {
    if (
      !!subscriptionInfo?.is_cancelled ||
      !!subscriptionInfo?.has_scheduled_downgrade ||
      !!subscriptionInfo?.has_scheduled_plan_change ||
      !!subscriptionInfo?.processing_plan_change ||
      isAppleOrAmpPayment
    ) {
      toast.error(
        isAppleOrAmpPayment
          ? APPLE_PAYMENT_UPGRADE_ERROR_TEXT
          : SUBSCRIPTION_PENDING_CHANGES_NOTIFICATION_MESSAGE,
      );
    } else {
      if (isTeamsTier) {
        if (isOwner) {
          navigate(AppRoutes.PAYMENT);
        } else {
          onOpenRequestUpgradeModal();
        }
      } else {
        navigate(AppRoutes.PAYMENT);
      }
    }
    if (onClick) {
      onClick();
    }
    sendGTMEvent(GTMEvent.UPGRADE_BUTTON_CLICKS);
  };

  if (isNinjaRetired) {
    return null;
  }

  return (
    <Button
      id={dataGTM}
      className={classNames('nj-upgrade-button', className)}
      onClick={handleUpgradeClick}
      disabled={isSubscriptionInfoLoading}
      color={color}
    >
      {title}
    </Button>
  );
};
